import type { ComponentType, SVGAttributes } from 'react';
import { Globe } from 'lucide-react';
import * as Flags from 'country-flag-icons/react/3x2';

type FlagComponent = ComponentType<SVGAttributes<SVGSVGElement>>;
type FlagIconSize = 'sm' | 'md' | 'lg';

const FLAG_COMPONENTS = Flags as Record<string, FlagComponent>;

const SIZE_CLASS: Record<FlagIconSize, string> = {
  // Fixed 3:2 boxes so SVG flags and Globe fallback share the same footprint (14×21, 18×27, 20×30px at scale 1)
  sm: 'h-3.5 w-[1.3125rem]',
  md: 'h-4.5 w-[1.6875rem]',
  lg: 'h-5 w-7.5',
};

type Props = {
  countryCode?: string;
  size?: FlagIconSize;
  className?: string;
};

export default function FlagIcon({ countryCode, size = 'md', className = '' }: Props) {
  const code = countryCode?.toUpperCase();
  const sizeClass = SIZE_CLASS[size];

  if (!code || code === 'ZZ') {
    return <Globe className={`${sizeClass} flex-shrink-0 text-secondary ${className}`} aria-hidden />;
  }

  const Flag = FLAG_COMPONENTS[code];
  if (!Flag) {
    return <Globe className={`${sizeClass} flex-shrink-0 text-secondary ${className}`} aria-hidden />;
  }

  return (
    <Flag
      aria-hidden
      className={`${sizeClass} flex-shrink-0 rounded-xs object-cover overflow-hidden ${className}`}
    />
  );
}
